import React from 'react'
import style from "./CompensationCase.module.css";

const Investigation = ({index, key_name, handleInput, data}) => {

  return (
    <div className={style.add_txt}>
      <div className={style.item_input_text}>
        <p className={style.tit}>일자</p>
        <input type="text" name={`${key_name}_date`} data-index={index} placeholder='' value={data?.date} onChange={handleInput}/>
      </div>

      <div className={style.item_input_text}>
        <p className={style.tit}>기관</p>
        <input type="text" name={`${key_name}_agency`} data-index={index} placeholder='' value={data?.agency} onChange={handleInput}/>
      </div>

      <div className={style.item_input_text}>
        <p className={style.tit}>내용(경위)</p>
        <div className={style.item_input_textarea}>
          <textarea name={`${key_name}_content`} data-index={index} value={data?.content} onChange={handleInput}/>
        </div>
      </div>

      <div className={style.item_input_text}>
        <p className={style.tit}>제출자료</p>
        <input type="text" name={`${key_name}_evidence`} data-index={index} placeholder='' value={data?.evidence} onChange={handleInput}/>
      </div>
    </div>
  )
}

export default Investigation
